import type { FC } from "react";
import Box from "@mui/material/Box";

/**
 * Знак помощника «Искры» (вариант B макета «Иконка ассистента Kit»,
 * 2026-10-09). Цвет берёт от текста родителя; у малой искры класс
 * `assistant-spark`, его анимирует кнопка в углу.
 */
export const SparklesIcon: FC<{ size: number }> = ({ size }) => (
  <Box
    component="svg"
    viewBox="0 0 24 24"
    aria-hidden
    sx={{ width: size, height: size, flexShrink: 0, overflow: "visible" }}
  >
    <path
      d="M10 5C10.7 10 13 12.3 18 13C13 13.7 10.7 16 10 21C9.3 16 7 13.7 2 13C7 12.3 9.3 10 10 5Z"
      fill="currentColor"
    />
    <path
      className="assistant-spark"
      d="M18 2.5C18.3 4.6 19.4 5.7 21.5 6C19.4 6.3 18.3 7.4 18 9.5C17.7 7.4 16.6 6.3 14.5 6C16.6 5.7 17.7 4.6 18 2.5Z"
      fill="currentColor"
    />
  </Box>
);
